import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import DashboardAppBar, { APP_BAR_BORDER, appBarHeight } from '../../components/dashboard/AppBar';
import DashboardDrawer from '../../components/dashboard/Drawer';
import useDashboardCompact from '../../styles/theme/surfaces/useDashboardCompact';

export default function DashboardLayout() {
  const compact = useDashboardCompact();

  return (
    <Box sx={{
      display: 'flex',
      height: '100vh',
    }}>
      <DashboardAppBar />
      <DashboardDrawer />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: `${appBarHeight(compact) + APP_BAR_BORDER}px`,
          p: compact ? 2 : 3,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
